<div formGroupName="cndt">
    <mat-expansion-panel class="expansion-panel-card" [expanded]="true">
        <mat-expansion-panel-header class="mat-card-header-text">
            <mat-panel-title>検索条件</mat-panel-title>
        </mat-expansion-panel-header>
        <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
            <mat-form-field appearance="outline"
                class="input-form-date tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                <mat-label>会社</mat-label>
                <mat-select formControlName="companycode" class="disabled-select-color">
                    <mat-option [value]="null"></mat-option>
                    <mat-option *ngFor="let type of companyList" [value]="type.value">{{type.viewValue}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline"
                class="input-form-date tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%] tw-ml-[54px]">
                <mat-label>入金地区</mat-label>
                <mat-select formControlName="rcvmnyAreacode" class="disabled-select-color">
                    <mat-option [value]="null"></mat-option>
                    <mat-option *ngFor="let type of rcvmnyAreaList" [value]="type.value">{{type.viewValue}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
            <mat-form-field appearance="outline"
                class="input-form-date tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                <mat-label>口座入金予定年月日(開始)</mat-label>
                <input matInput [matDatepicker]="start" formControlName="kouzaRcvmnyytiymdStart" maxlength="10">
                <mat-datepicker-toggle matSuffix [for]="start"></mat-datepicker-toggle>
                <mat-datepicker #start></mat-datepicker>
            </mat-form-field>
            <span style="margin-left: 40px">～</span>
            <mat-form-field appearance="outline"
                class="input-form-date tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                <mat-label>口座入金予定年月日(終了)</mat-label>
                <input matInput [matDatepicker]="end" formControlName="kouzaRcvmnyytiymdEnd" maxlength="10">
                <mat-datepicker-toggle matSuffix [for]="end"></mat-datepicker-toggle>
                <mat-datepicker #end></mat-datepicker>
            </mat-form-field>
        </div>
        <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
            <mat-form-field appearance="outline"
                class="input-form-select tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[50%]">
                <mat-label>入金口座</mat-label>
                <mat-select formControlName="rcvmnyKouzacode" class="disabled-select-color">
                    <mat-option [value]="null"></mat-option>
                    <mat-option *ngFor="let type of rcvmnyKouzaList" [value]="type.value">{{type.viewValue}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
            <mat-form-field appearance="outline"
                class="input-form-select tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                <mat-label>入金形態</mat-label>
                <mat-select formControlName="rcvmnyKeitaiCode" class="disabled-select-color"
                    (valueChange)="onChangeRcvmnyKeitai($event)">
                    <mat-option [value]="null"></mat-option>
                    <mat-option *ngFor="let type of rcvmnyKeitaiList" [value]="type.value">{{type.viewValue}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline"
                class="input-form-select tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[40%] tw-ml-[54px]">
                <mat-label>口座入金機関</mat-label>
                <mat-select formControlName="kouzaRcvmnyBankofficecode" class="disabled-select-color">
                    <mat-option [value]="null"></mat-option>
                    <mat-option *ngFor="let type of kouzaRcvmnyFcltList" [value]="type.value">{{type.viewValue}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
            <mat-form-field appearance="outline"
                class="input-form-select tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                <mat-label>入金突合ステータス</mat-label>
                <mat-select formControlName="rcvmnyReconciliationStatuscode" class="disabled-select-color"
                    (valueChange)="onChangeStatus($event)">
                    <mat-option *ngFor="let status of codeMap?.get('S300190')"
                        [value]="status.userCode">{{status.hyojiCont}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
            <mat-form-field appearance="outline"
                class="input-form-date tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                <mat-label>報告年月日(開始)</mat-label>
                <input matInput [matDatepicker]="reportStart" formControlName="reportYearmonthdateStart" maxlength="10">
                <mat-datepicker-toggle matSuffix [for]="reportStart"></mat-datepicker-toggle>
                <mat-datepicker #reportStart></mat-datepicker>
            </mat-form-field>
            <span style="margin-left: 40px">～</span>
            <mat-form-field appearance="outline"
                class="input-form-date tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
                <mat-label>報告年月日(終了)</mat-label>
                <input matInput [matDatepicker]="reportEnd" formControlName="reportYearmonthdateEnd" maxlength="10">
                <mat-datepicker-toggle matSuffix [for]="reportEnd"></mat-datepicker-toggle>
                <mat-datepicker #reportEnd></mat-datepicker>
            </mat-form-field>
        </div>
        <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center ">
            <mat-checkbox id="confirmed"
                class="check-box tw-ml-[50px] tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[25%]"
                color="primary" formControlName="reportedKafusoku">報告済過不足
            </mat-checkbox>
        </div>
        <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-end tw-items-center tw-content-center">
            <mat-action-row class="btn_area_right expansion-panel-actions">
                <button type="submit" mat-raised-button color="primary" [disabled]="searchConditionForm.invalid"
                    class="btn">検索</button>
            </mat-action-row>
            <mat-action-row class="btn_area_right expansion-panel-actions">
                <button type="button" mat-raised-button color="primary" class="btn"
                    (click)="onClickClear()">クリア</button>
            </mat-action-row>
        </div>
    </mat-expansion-panel>
</div>